import { useState } from "react";
import { PasswordService } from "../../../../../services/PasswordService";
import { InputDefault } from "../../../../../components/forms/InputDefault";
import { FaFloppyDisk } from "react-icons/fa6";

const inputClass =
    "w-full px-4 py-3 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all";

export const TabSecuritySetting = () => {
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [data, setData] = useState({
        old_password: "",
        new_password: "",
        confirm_password: "",
    });

    // --- TAMBAHKAN FUNGSI INI ---
    // Fungsi untuk menangani perubahan input pada setiap field
    const handleChange = (field) => (e) => {
        setData((prev) => ({
            ...prev,
            [field]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoadingSubmit(true);
        try {
            // --- SESUAIKAN NAMA FIELD DENGAN BACKEND ---
            // Pastikan key object sesuai dengan validasi Laravel (current_password, password, password_confirmation)
            const payload = {
                current_password: data.old_password,
                password: data.new_password,
                password_confirmation: data.confirm_password,
            };

            // Kirim payload (hapus { data: ... } jika servicenya tidak butuh wrapper)
            await PasswordService.update({data: payload});

            // Optional: Reset form setelah sukses
            setData({
                old_password: "",
                new_password: "",
                confirm_password: "",
            });

            alert("Password berhasil diubah!");

        } catch (err) {
            console.error(err);
            // handleError(err, "Gagal mengubah password.");
            alert("Gagal mengubah password. Pastikan password lama benar.");
        } finally {
            setLoadingSubmit(false);
        }
    };

    return (
        <>
            <section className="space-y-6 animate-in fade-in duration-300">
                <header>
                    <h3 className="text-lg font-bold text-gray-100">Keamanan</h3>
                    <p className="text-xs text-slate-500 mt-1">Ganti password secara berkala untuk keamanan data.</p>
                </header>
                <div className="space-y-5 max-w-md">
                    <InputDefault
                        type="password"
                        label="Password Lama"
                        placeholder="Masukkan password lama"
                        value={data.old_password}
                        // Gunakan handleChange
                        onChange={handleChange('old_password')}
                    />

                    <InputDefault
                        label="Password Baru"
                        type="password"
                        placeholder="Masukkan password baru"
                        value={data.new_password}
                        onChange={handleChange('new_password')}
                    />

                    <InputDefault
                        type="password"
                        label="Konfirmasi Password Baru"
                        placeholder="Konfirmasi password baru"
                        value={data.confirm_password}
                        onChange={handleChange('confirm_password')}
                    />
                </div>
            </section>

            <div
                className="px-6 pt-4 flex justify-end"
                style={{ borderTop: "1px solid rgba(51, 65, 85, 0.3)" }}
            >
                <button
                    // PERBAIKAN: Gunakan onClick (camelCase), bukan onclick
                    onClick={handleSubmit}
                    className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold text-white transition-all duration-200"
                    style={{
                        background: "linear-gradient(135deg, #0077B6, #00B4D8)",
                        boxShadow: "0 4px 15px rgba(0, 180, 216, 0.2)",
                    }}
                >
                    <FaFloppyDisk className={`${loadingSubmit ? "animate-spin" : ""}`} /> Simpan Perubahan
                </button>
            </div>
        </>
    )
}